import { z } from 'zod';
import {
  emailSchema,
  nameAndCode,
  optionalString,
  percentageSchema,
  phoneSchema,
  requiredString,
} from './common';

const panelFields = {
  ...nameAndCode,
  owner_name: requiredString('Owner name'),
  discount_percentage: percentageSchema,
  phone_number: phoneSchema,
  email: emailSchema,
  contract: optionalString(),
};

// `user_id` is set from the authenticated session, not the request body.
export const createPanelSchema = z.object(panelFields);
export type CreatePanelInput = z.infer<typeof createPanelSchema>;

// Identical to create — a panel has no field that is only settable once.
export const updatePanelSchema = createPanelSchema;
export type UpdatePanelInput = z.infer<typeof updatePanelSchema>;
